import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import DetailsCustomer from "./DetailsCustomer";
import EditCustomer from "./EditCustomer";
import $ from "jquery";

const ListCustomer = () => {
  const navigate = useNavigate();
  const {
    userRole,
    userToken,
    setCustomerObj,
    setCustomerFlag,
    SetSharedObject,
    sharedObject,
  } = useUserStore((state) => ({
    setCustomerObj: state.setCustomerObj,
    userRole: state.userRole,
    userToken: state.userToken,
    setCustomerFlag: state.setCustomerFlag,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
  }));
  const [userObj, setUserObj] = useState([]);
  const [custInfo, setCustInfo] = useState();
  const [processing, SetProcessing] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [refreshObj, SetRefreshObj] = useState(Date.now());

  const getCustomers = async () => {
    SetProcessing(true);
    let call = "/users/GetVendors";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      getCust(res.data.data.vendors);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };
  useEffect(() => {
    if (
      sharedObject.CustomerObj != undefined &&
      sharedObject.CustomerObj != null
    ) {
      userDetailsFunc(sharedObject.CustomerObj);
      var a = [];
      a[0] = sharedObject.CustomerObj;
      getCust(a);
      SetSharedObject("CustomerObj", undefined);
    } else {
      getCust(sharedObject.vendorsObj);
    }
  }, [sharedObject.refreshCustObj]);
  const getCust = async (obj) => {
    let tempObj = [];
    let opt = ["Add Top Level Org", "Upload Org"];
    for (const row of obj) {
      let cs = (
        <Link
          underline="none"
          className="font-weight-bold"
          onClick={(el) => {
            userDetailsFunc(row, "show");
          }}
        >
          {row.name}
        </Link>
      );
      row.EditCourse = cs;
      let vw = (
        <a
          href="javascript:void(0);"
          underline="none"
          className="font-weight-bold"
          onClick={() => {
            ViewCustomer(row);
          }}
        >
          VIEW
        </a>
      );
      row.View = vw;
      let select = (
        <select
          onChange={(el) => {
            userActions(row, el.target.value);
          }}
          value={0}
          id="UserActions"
          className="form-control form-control-sm p-0 ht-4"
        >
          <option value="">Select</option>
          {opt.map((el, i) => {
            return (
              <option key={i} value={el}>
                {el}
              </option>
            );
          })}
        </select>
      );
      row.Actions = select;
      row.Show = true;
      row.dCreated = new Date(row.dateCreated);
      row.timeStamp = Date.now();
      tempObj.push(row);
    }
    setUserObj(tempObj);
    SetProcessing(false);
  };

  const userDetailsFunc = async (row) => {
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(row.id);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      row.org = res.data.data;
      setSelectedProduct(row);
      setCustomerObj(row);
      setCustInfo({ ...row, timeStamp: Date.now() });
      let o = {
        Flag: "customer",
        Navigate: "customer",
        name: row.name,
        id: row.id,
      };
      SetSharedObject("UserIdEmail", o);
      $("#detailsCustomerModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }

    SetProcessing(false);
  };
  const userActions = async (row, type) => {
    let cust = {
      ...row,
      Name: row.name,
      Type: "top",
      OrgType: "top",
      VendorId: row.id,
    };
    setCustomerObj(cust); //
    SetSharedObject("orgActionObj", cust);
    SetSharedObject("CustomerPermissionsObj", cust);
    if (type === "Add Top Level Org") {
      setCustomerFlag(false);
      navigate("/toplevel-org-registration");
    } else {
      navigate("/upload-organization");
    }
  };
  const ViewCustomer = (row) => {
    SetSharedObject("CustomerPermissionsObj", row);
    row.Flag = "customer";
    row.Navigate = "customer";
    row.Name = row.name;
    setCustomerObj(row);
    SetSharedObject("UserIdEmail", row);
    navigate("/organizations");
  };

  const userEdit = (row) => {
    $("#editCustomerModal").modal("show");
  };
  const userUpdate = (el) => {
    let tempObj = [];
    for (const row of userObj) {
      if (row.id === el.id) {
        row.billingAddress = el.billingAddress;
      }
      tempObj.push(row);
    }
    setUserObj(tempObj);
    userDetailsFunc(el);
    //getCustomers();
    $("#editCustomerModal").modal("hide");
  };
  const [nameSearch, setNameSearch] = useState("");
  const SearchCustomer = () => {
    console.log(nameSearch);
    if (nameSearch === "") {
      getCust(sharedObject.vendorsObj);
      return;
    }
    const newObj = userObj.filter((el) =>
      el.name.toUpperCase().includes(nameSearch.toUpperCase())
    );
    setUserObj(newObj);
  };
  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchCustomer();
    }
  };
  const deletedDate = (dt) => {
    return dt.dateCreated ? new Date(dt.dateCreated).toLocaleString() : null;
  };
  const [sortFlag, SetSortFlag] = useState(false);
  const nameBodyTemplate = (product) => {
    SetSortFlag(!sortFlag);
    if (sortFlag) userObj.sort((a, b) => a.name.localeCompare(b.name));
    else userObj.sort((a, b) => b.name.localeCompare(a.name));
  };
  return (
    <div className="ListCustomer">
      <div className="HeaderCustomerTools">
        <div className="HeaderTools">
          <header className="ht-6">
            <div className="title-label">List</div>
            <div className="mid-header-bar">
              {/*Search by name*/}
              <div className="spacer-inline spacer-margin6">
                <div className="input-group">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search by Name"
                    aria-label="Enter Customer"
                    aria-describedby="Search Customer by Name"
                    onChange={(el) => setNameSearch(el.target.value)}
                    onKeyPress={SearchWithEnter}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="basic-addon2"
                      onClick={SearchCustomer}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
      {/*Grid*/}
      <section className="grid-layout">
        <DataTable
          value={userObj}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 25, 50]}
          tableStyle={{ minWidth: "50rem" }}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          selectionMode="single"
          selection={selectedProduct}
          onSelectionChange={(e) => setSelectedProduct(e.value)}
          columnResizeMode="expand"
          resizableColumns
          dataKey="id"
          metaKeySelection={false}
          sortField="dCreated"
          sortOrder={-1}
        >
          <Column
            field="EditCourse"
            header="Customer Name"
            sortable
            sortField={(e) => nameBodyTemplate(e)}
          ></Column>
          <Column
            field="baseDomain.name"
            header="Base Domain"
            sortable
          ></Column>
          <Column
            field="View"
            header="Organizations"
            className="w-xsm ctr"
          ></Column>
          <Column
            field="dCreated"
            header="Date Created"
            className="w-md8"
            body={deletedDate}
            sortable
          ></Column>
          <Column
            field="billingAddress.city"
            header="City"
            className="w-md2"
            sortable
          ></Column>
          <Column
            field="billingAddress.state"
            header="State"
            className="w-sm"
            sortable
          ></Column>
          <Column
            field="billingAddress.zip"
            header="Zip"
            className="w-sm"
            sortable
          ></Column>
          <Column
            field="createdBy"
            header="Created By"
            className="w-md7"
            sortable
          ></Column>
          <Column field="Actions" header="Actions" className="w-md2"></Column>
        </DataTable>
      </section>

      <DetailsCustomer
        userDetails={custInfo}
        CloseDetailUser={(el) => {
          //$("#detailsCustomerModal").modal("hide");
          setCustInfo(el);
        }}
        userEdit={userEdit}
      />

      <EditCustomer
        userDetails={custInfo}
        CloseDetailUser={(el) => {
          $("#editCustomerModal").modal("hide");
        }}
        userUpdate={userUpdate}
      />
      {processing ? <div className="loading"></div> : null}
    </div>
  );
};

export default ListCustomer;
